// import "@babel/polyfill"
import "core-js"
import "regenerator-runtime/runtime"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import VueI18n from 'vue-i18n'
import langs from './assets/langs'
import VueGtag from "vue-gtag";
import "./assets/js/preload"
import "bootstrap"; // Import js file
import "@/assets/css/style.scss";
import 'aos/dist/aos.css'
import Bowser from "bowser"
const browser = Bowser.getParser(window.navigator.userAgent);
store.commit("setBrowser", browser.getBrowser())

import Chat from 'vue-beautiful-chat'
Vue.use(Chat)

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faExternalLinkAlt,
  faBars,
  faTimes,
  faLink
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import pvm from 'p5-vue-mirror'
Vue.use(pvm)

// store.dispatch("loadSvgData", "/scenes/gov_obj.svg")
// store.dispatch("loadSvgData", "/scenes/gov_bkg.png")
// store.dispatch("loadSvgData", "/scenes/traffic_obj.svg")
// store.dispatch("loadSvgData", "/scenes/traffic_bkg.png")
// store.dispatch("loadSvgData", "/scenes/health_obj.svg")
// store.dispatch("loadSvgData", "/scenes/health_bkg.png")

// console.log(router)
if (window.location.pathname == "/") {
  //不自動關閉載入頁面
  store.dispatch("triggerLoading", 10000)
} else {
  store.dispatch("triggerLoading", 3000)

}

console.log("==== 2020 Monoame Design 墨雨設計 ====")

// IE11 polyfill support
if ('NodeList' in window && !NodeList.prototype.forEach) {
  console.info('polyfill for IE11');
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

library.add(faBars, faTimes, faLink, faExternalLinkAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)

window.axios = axios;
window.Vue = Vue;

const locale = localStorage.getItem('lang') || 'zh'
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale,
  messages: langs
})
Vue.use(VueGtag, {
  config: {
    id: "UA-113459032-2"
  }
}, router);
window.router = router
Vue.config.productionTip = false
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  mounted() {
    // prerender
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app')

export {
  i18n
};